import { FormattedMessage } from 'react-intl'

import { getImage } from '@/lib/images'
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/shared/ui'

import { ContractorsTransaction } from '../../types'

type Props = {
  isOpen: boolean
  onOpenChange: (open: boolean) => void
  payment?: ContractorsTransaction
}

export const PendingPaymentDialog = ({ isOpen, onOpenChange }: Props) => {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent>
        <img
          src={getImage({ name: 'lock' })}
          alt=""
          aria-hidden
          className="mx-auto size-32"
        />

        <div className="p-2" />
        <DialogHeader>
          <DialogTitle>
            <FormattedMessage
              id="contractor.delete.dialog.pendingPayments"
              defaultMessage="Unable to delete contractor"
            />
          </DialogTitle>

          <div className="flex flex-col">
            <DialogDescription>
              <FormattedMessage
                id="contractor.delete.pendingPaymentsDescription"
                defaultMessage="This contractor has pending payments. You must process them or dismiss them before deleting the contractor"
              />
            </DialogDescription>
          </div>
        </DialogHeader>

        <div className="p-4" />

        <Button width="full" onClick={() => onOpenChange(false)}>
          <FormattedMessage id="action.close" defaultMessage="Close" />
        </Button>
      </DialogContent>
    </Dialog>
  )
}
